export const SECTION_NAME = 'Entitlements Grant Change Log';

export const COLUMNS = {
    ACTION_NAME: 'actionName',
    ACTION_DESCRIPTION: 'actionDescription',
    TIMESTAMP: 'timestamp',
    INITIATOR: 'initiator',
    REASON: 'reason',
};

export const HEADERS = {
    [COLUMNS.ACTION_NAME]: 'Action Type',
    [COLUMNS.ACTION_DESCRIPTION]: 'Action Description',
    [COLUMNS.INITIATOR]: 'Initiator',
    [COLUMNS.TIMESTAMP]: 'Timestamp',
    [COLUMNS.REASON]: 'Reason',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.ACTION_NAME,
        fixed: true,
        defaultWidth: 324,
        minWidth: 324,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.ACTION_DESCRIPTION,
        fixed: false,
        defaultWidth: 600,
        minWidth: 500,
        maxWidth: 800,
    },
    {
        columnId: COLUMNS.INITIATOR,
        fixed: false,
        defaultWidth: 300,
        minWidth: 250,
        maxWidth: 350,
    },
    {
        columnId: COLUMNS.TIMESTAMP,
        fixed: false,
        defaultWidth: 300,
        minWidth: 250,
        maxWidth: 350,
    },
    {
        columnId: COLUMNS.REASON,
        fixed: false,
        defaultWidth: 300,
        minWidth: 250,
        maxWidth: 350,
    },
];
